import { useCallback, useEffect, useState } from 'react';
import { SpaceModel, Image } from "../../interfaces/Space";
import "../../styles/layouts/infoimages.scss";
import UseSwipe from '../../hooks/UseSwipe';
import ImageSwipe from '../ImageSwipe';
import { Gallery, Image as GalleryImage } from "react-grid-gallery";
import { isMobile } from 'react-device-detect';

type Props = {
    space: SpaceModel | undefined;
    wrap?: boolean
}


export default function InfoImages({ space, wrap }: Props) {
    const swipeProps = UseSwipe({
        direction: 'vertical',
        speedThreshold: 2,
        action: () => overlayOff()
    });

    const [selected, selectImage] = useState<Image>();
    const [zoomViewOpen, setZoomViewOpen] = useState<boolean>(false);
    const [sourceImgArr, setSourceImgArr] = useState<Image[]>([])
    const [imageArr, setImageArr] = useState<GalleryImage[]>([]);

    const overlayOn = (idx: number) => {
        document.body.classList.add('overlay-on');
        setZoomViewOpen(true)
        selectImage(sourceImgArr[idx]);
    }
    const overlayOff = () => {
        document.body.classList.remove('overlay-on');
        setZoomViewOpen(false)
        selectImage(undefined);
    }

    const fetchImage = useCallback(async (imgUrl: string): Promise<GalleryImage> => {
        const res = await fetch(imgUrl);
        const blobRes = await res.blob();
        const bmp = await createImageBitmap(blobRes);

        return {
            src: imgUrl,
            width: bmp.width,
            height: bmp.height
        };
    }, [])

    const fetchAllImages = useCallback(async () => {
        const promiseArr: any[] = [];
        const imgs = space?.imageUrls;
        const srcImgs = [];
        const galleryImgs = [];
        if (imgs && imgs.length > 0) {
            imgs.forEach((img) => {
                promiseArr.push(fetchImage(img.url));
            })

            const res = await Promise.allSettled(promiseArr);
            for (let i = 0; i < res.length; i++) {
                const img = res[i];

                if (img.status === 'fulfilled') {
                    srcImgs.push(imgs[i]);
                    galleryImgs.push(img.value);
                }
            }

            setSourceImgArr(srcImgs);
            setImageArr(galleryImgs);
        }
    }, [space, fetchImage])


    const [gallerySize, setGallerySize] = useState(100);
    useEffect(() => {
        setGallerySize(isMobile ? 100 : 150)
    }, [isMobile])


    useEffect(() => {
        fetchAllImages();
    }, [space])



    return <div {...swipeProps} className="infoimages-container">
        {imageArr && imageArr.length > 0 && <Gallery
            enableImageSelection={false}
            onClick={(index) => overlayOn(index)}
            defaultContainerWidth={gallerySize}
            rowHeight={gallerySize} images={imageArr} />}
        <ImageSwipe
            open={zoomViewOpen}
            images={space?.imageUrls || []}
            onClickImage={overlayOff}
            clickedImage={selected} />
    </div>
}